import { apiClient } from "./ApiClient";

const ROUTE = "infappconfigs";

export const getInfAppConfigsAPI = async ({ config_names = [] } = {}) => {
  const res = await apiClient.post(ROUTE, {
    action: "getConfigs",
    config_names,
  });
  return res?.data ?? res;
};


export const setInfAppConfigsAPI = async ({ updatedBy, updates = [] } = {}) => {
  const res = await apiClient.post(ROUTE, {
    action: "setConfigs",
    updatedBy,
    updates,
  });
  return res?.data ?? res;
};
